import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { ValidationFormTypes } from "../../../../Pages/SubmitProccess/ValidationForm/ValidationForm";

export type UserSubServiceFilesLoadAction = {
  type: string;
  payload: ValidationFormTypes;
};

export type UserSubServiceFilesData = {
  data: {};
};

export const UserSubServiceFiles = new ReduxFetchState<
  UserSubServiceFilesData,
  ValidationFormTypes,
  any
>("userSubServiceFiles");

export function* watchUserSubServiceFiles(
  action: UserSubServiceFilesLoadAction,
) {
  try {
    const { question_id, file_ids, file_link, user_service_id } =
      action.payload;

    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: UserSubServiceFilesData = yield axios({
      url: `/api/v1/ai/user-sub-service/files`,
      method: "POST",
      headers: {
        lang,
      },
      data: { file_ids, user_service_id, file_link },
    });

    yield put(UserSubServiceFiles.actions.loadSuccess({ data: data.data }));
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(UserSubServiceFiles.actions.loadFailure(e.message));
  }
}

export function* userSubServiceFilesSagas() {
  yield takeEvery(
    UserSubServiceFiles.actionTypes.load,
    watchUserSubServiceFiles,
  );
}

export function useUserSubServiceFiles() {
  const { loading, data, ...userSubServiceFilesState } = useAppSelector(
    (state) => state.userSubServiceFiles,
  );
  const dispatch = useAppDispatch();

  const dispatchUserSubServiceFiles = useCallback(
    (data: ValidationFormTypes) => {
      dispatch(UserSubServiceFiles.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...userSubServiceFilesState,
    dispatchUserSubServiceFiles,
    userSubServiceFilesLoading: loading,
    userSubServiceFilesData: data,
  };
}

export const {
  actionTypes: userSubServiceFilesActionsTypes,
  actions: userSubServiceFilesActions,
  reducer: userSubServiceFilesReducer,
} = UserSubServiceFiles;
